import {initWebComponent} from "@/helpers/web-component-helper";
import {activateUserSessionByID, disableUserSessionByID, getUserSessionByID} from "@/helpers/user-session-helper";
import {
    addClassBySelector,
    hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {initPopper} from "@/modules/popper.js";

export class BookmarkUserSessionStopButtonComponent extends HTMLElement {
    constructor(){
        super();

        let active = Boolean(this.getAttribute('data-active'))
        const id = this.getAttribute('data-id')

        const template = document.createElement('template');

        template.innerHTML = `<button class="btn btn-sm borderless icon-btn popper-header float-right">
           <span><i class="fa fa-stop"></i></span>
           <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                 Bookmark stoppen
                <div class="arrow" data-popper-arrow=""></div>
          </div>
        </button>`
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            disableUserSessionByID(id)
            initPopper()
            removeClassBySelector('.card-user-session', 'bg-light')
        })
    }
}
